<template>
  <div class="user-card">
    <div class="user-card__common">
      <div class="user-card__avatar">
        <avatar
          v-if="user.avatar_resource_id"
          class="user-avatar ms-text"
          size="large"
          :src="
            `${mainUrl}/api/download_resource/${user.avatar_resource_id}?access_token=${token}`
          "
        />
        <avatar v-else class="user-avatar ms-text" size="large">
          {{ getNameInitials(user) }}
        </avatar>
      </div>
      <div class="user-card__info">
        <div class="user-card__name ms-subhead">
          {{ getFullName(user) }}
        </div>
         <div class="user-card__company ms-text">
          {{ (user.department && user.department.name) || "Не указан" }}
        </div>
        <div class="user-card__position ms-help">
          {{ (user.position && user.position.name) || "Не указана" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mainUrl } from '@/config/urls'
import { getFullName, getNameInitials } from '@/utils'

export default {
  props: ['user'],
  data () {
    return {
      token: this.$store.state.auth.token,
      mainUrl
    }
  },
  methods: {
    getFullName,
    getNameInitials
  }
}
</script>

<style lang="less">
.user-card {
  &__common {
    display: flex;
  }

  .ivu-avatar-large {
    width: 64px;
    height: 64px;
    line-height: 64px;
    border-radius: 50%;

    & > * {
      line-height: 64px;
    }
  }

  &__info {
    margin-left: 16px;
  }

  &__company {
    margin-top: 8px;
  }
}
</style>
